export default __webpack_public_path__ + "static/media/remainder-history-icon.dc03e81e.svg";